import { useFeature } from '@farmersdog/ab-testing';
import type { UseFeatureOptions } from '@farmersdog/ab-testing';

import type { AnonymousFeatures, UserFeatures } from './features';

type ContentFeatureKey = keyof (AnonymousFeatures & UserFeatures);

export function useContentFeature<K extends ContentFeatureKey>(
  name: K,
  options?: UseFeatureOptions
) {
  return useFeature<AnonymousFeatures, UserFeatures, K>(name, options);
}
